export function conversions(value) {
  return value.total_conversions.aggregate.count - value.total_paying
}
